<template>
  <div class="dischargeCapacity">
    <title1 type="1" title="累计工单及响应情况" />
    <div style="width: 440px; height: 280px">
      <MyEcharts
        v-if="showcdata"
        :id="'smart3_5'"
        :options="cdata"
        style="width: 440px; height: 265px"
      />
    </div>
  </div>
</template>

<script>
import title1 from "@/views/exposition/components/title4";
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import * as echarts from "echarts5";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    MyEcharts,
    title1,
  },
  data() {
    return {
      showcdata: false,
      // title:"月度充/放电量"
      cdata: {
        tooltip: {
          trigger: "axis",
          show: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: {
          top: "23%",
          fontSize: 18,
        },
        color: ["#FFCE51", "#82F2F4"],
        xAxis: {
          type: "category",
          axisLabel: {
            //x轴文字的配置
            show: true,
            interval: 0, //使x轴文字显示全
          },
          boundaryGap: true,
          data: ["一级告警", "二级告警", "三级告警", "四级告警"],
        },
        title: {
          text: "单位: 条",
        },
        yAxis: {
          type: "value",
          nameTextStyle: {
            fontSize: 26,
          },
        },
        series: [
          {
            name: "已处理",
            type: "bar",
            smooth: true,
            data: [80, 55, 75, 80],
            barWidth: 15,
            tooltip: {
              valueFormatter: function (value) {
                return value + "（条）";
              },
            },
            itemStyle: {
              barBorderRadius: [2, 2, 0, 0], //柱体圆角
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  //代表渐变色从正上方开始
                  offset: 0, //offset范围是0~1，用于表示位置，0是指0%处的颜色
                  color: "rgba(26, 239, 239, 1)",
                }, //柱图渐变色
                {
                  offset: 1, //指100%处的颜色
                  color: "rgba(26, 239, 239, 0)",
                },
              ]),
            },
            lineStyle: {
              color: "#1AEFEF",
            },
          },
          {
            name: "待处理",
            type: "bar",
            smooth: true,
            data: [60, 70, 90, 65],
            barWidth: 15,
            tooltip: {
              valueFormatter: function (value) {
                return value + "（条）";
              },
            },
            itemStyle: {
              barBorderRadius: [2, 2, 0, 0], //柱体圆角
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  //代表渐变色从正上方开始
                  offset: 0, //offset范围是0~1，用于表示位置，0是指0%处的颜色
                  color: "rgba(255, 209, 92, 1)",
                }, //柱图渐变色
                {
                  offset: 1, //指100%处的颜色
                  color: "rgba(255, 209, 92, 0)",
                },
              ]),
            },

            lineStyle: {
              color: "#FFCE51",
            },
          },
        ],
      },
      query: this.$route.query,
    };
  },
  mounted() {
    this.$bus.$on("onfangdiangonglv", () => {
      this.getBattery24hours();
    });
    this.getBattery24hours();
  },
  destroyed() {
    // this.$bus.$off('onfangdiangonglv')
  },
  methods: {
    //获取24小时电次数分布
    getBattery24hours() {
      let cityCode = this.query.province || this.query.city || "000000";
      let params = {
        enCode: "zngf-qg-j24xsgsdfdxl", // 接口code
        // 接口传参
        "@adcode": cityCode,
      };
      this.showcdata = false;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "发电效率与收益排行榜");
          if (res) {
            let data = [];
            let data2 = [];
            let xAxis = [];
            res.forEach((item) => {
              xAxis.push(item.cur_hour); // 小时
              data.push(item.generate_electricity); // 发电效率
            });
            // this.cdata.xAxis.data = xAxis;
            // this.cdata.series[0].data = data;
            this.showcdata = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>
